import { ConfigurationScanDataMatrix } from "./ConfigurationScanDataMatrix";
import { CONFIGURATION_SUBMIT_SCAN_VALUE } from "./configurationDeviceFields";

export function ConfigurationSubmitDataMatrix({
  className,
  sizePx = 48,
}: {
  className?: string;
  sizePx?: number;
}): JSX.Element {
  return (
    <ConfigurationScanDataMatrix
      text={CONFIGURATION_SUBMIT_SCAN_VALUE}
      className={className}
      sizePx={sizePx}
      ariaLabel="Scan Data Matrix ECC200 to submit"
      title="Scan to submit"
    />
  );
}
